<template>
  <div class="topup-container">
    <banner-top />
    <div class="topup-header">
      <div class="container">
        <h1>Potwierdź dane doładowania</h1>
      </div>
    </div>
    <topup-summary />
  </div>
</template>

<script>
import TopupSummary from '@/eon/components/Topup/Summary'
import BannerTop from '@/eon/components/BannerTop'

export default {
  name: 'TopupSummaryView',
  components: {
    BannerTop,
    TopupSummary
  }
}
</script>
